globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.DashboardController = (function(superClass) {

    utils.extend(DashboardController, superClass);

    function DashboardController() {
        return DashboardController.__super__.constructor.apply(this, arguments);
    }

    $.extend(DashboardController.prototype, {
        init: function(){
            this._initEvents();

            return DashboardController.__super__.init.apply(this, arguments);
        },
        _initEvents: function(){
            $('.see-other-direct-platforms').on('click', function(){
                $(this).hide();
                $(this).closest('.multicast-thumbnail').find('.other-direct-platforms-container').show();
            });
        }
    });

    return DashboardController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
